// @flow

import { translate } from '../../../base/i18n';
import { IconMaterialList } from '../../../base/icons';
import { connect } from '../../../base/redux';
import { AbstractButton, type AbstractButtonProps } from '../../../base/toolbox/components';
import React from "react";

/**
 * The type of the React {@code Component} props of {@link MaterialListButton}.
 */
type Props = AbstractButtonProps & {

    /**
     * Whether or not the participants pane is open.
     */
    _isOpen: boolean,
};

/**
 * Implementation of a button for accessing participants pane.
 */
class MaterialListButton extends AbstractButton<Props, *> {
    buttonLabel = 'toolbar.buttonLabel.materiallist';
    accessibilityLabel = 'toolbar.accessibilityLabel.materiallist';
    icon = IconMaterialList;
    label = 'toolbar.materiallist';
    tooltip = 'toolbar.materiallist';

    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * 웹 접근성에 알맞은 focus 이동을 위해 추가
     * @returns {JSX.Element}
     */
    render(): React$Node {
        return (
            <div
                id = 'toolbar-material_list'
                className = 'toolbar-button-with-badge'>
                {super.render()}
            </div>
        );
    }
}

/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Props}
 */
const mapStateToProps = state => {
    return {
        _isOpen: state['features/material-list'].isOpen
    };
};

export default translate(connect(mapStateToProps)(MaterialListButton));
